document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      if (menu) menu.hidden = open;
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const options = form.querySelectorAll('[name="purchase_option"]');
    const quantity = form.querySelector('[name="quantity"]');
    const submitLabel = form.querySelector('[data-submit-label]');
    const submitButton = form.querySelector('.product-submit');
    const bundleDetails = form.querySelector('.purchase-options');
    options.forEach((option) => {
      option.addEventListener('change', () => {
        const bundle = option.value === 'bundle';
        if (quantity) quantity.value = '1';
        if (submitLabel) submitLabel.textContent = bundle ? 'Add bundle to bag' : 'Add to bag';
      });
    });

    form.addEventListener('submit', async (event) => {
      const selectedOption = form.querySelector('[name="purchase_option"]:checked');
      if (!selectedOption || selectedOption.value !== 'bundle') return;

      const productVariant = form.querySelector('[name="id"]');
      const bundleVariantId = bundleDetails?.dataset.bundleVariantId;
      if (!productVariant?.value || !bundleVariantId) return;

      event.preventDefault();
      if (submitButton) submitButton.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Adding your creative set...';

      try {
        const response = await fetch(bundleDetails.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(productVariant.value), quantity: 1, properties: { '_ColorIt bundle': 'Book + Gel Pens' } },
              { id: Number(bundleVariantId), quantity: 1, properties: { '_ColorIt bundle': 'Book + Gel Pens' } }
            ]
          })
        });
        if (!response.ok) throw new Error('Bundle could not be added');
        window.location.assign(bundleDetails.dataset.cartUrl || '/cart');
      } catch (error) {
        if (submitButton) submitButton.disabled = false;
        if (submitLabel) submitLabel.textContent = 'Please try again';
      }
    });
  });
});
/* ColorIt PDP v3: truthful reviews, Kitenzo parent bundles, and sold-out states. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pdp-section]').forEach(function (section) {
    var mainImage = section.querySelector('.pdp2-gallery__main');
    section.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.gallerySrc;
        mainImage.removeAttribute('srcset');
        mainImage.alt = thumb.dataset.galleryAlt || mainImage.alt;
        section.querySelectorAll('[data-gallery-thumb]').forEach(function (item) { item.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
    var form = section.querySelector('[data-pdp-form]');
    if (!form) return;
    var variantInput = form.querySelector('[data-variant-input]');
    var variantSelect = form.querySelector('[data-variant-select]');
    var submit = form.querySelector('[data-pdp-submit]');
    var bis = form.querySelector('#BIS_trigger');
    var label = form.querySelector('[data-atc-label]');
    var price = form.querySelector('[data-atc-price]');
    var error = form.querySelector('[data-form-error]');
    function money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(Number(cents || 0) / 100); }
    function selectedOption() { return form.querySelector('[data-purchase-option]:checked'); }
    function singleAvailable() { return variantSelect ? variantSelect.options[variantSelect.selectedIndex].dataset.available === 'true' : variantInput.dataset.available === 'true'; }
    function refreshOffer() {
      var option = selectedOption();
      form.querySelectorAll('[data-set-card]').forEach(function (card) { card.classList.toggle('is-active', card.contains(option)); });
      if (!option) return;
      var isBundle = option.value === 'bundle';
      var available = isBundle ? submit.dataset.bundleAvailable === 'true' : singleAvailable();
      var shownPrice = isBundle ? Number(submit.dataset.bundlePrice || 0) : Number(submit.dataset.singlePrice || 0);
      label.textContent = option.dataset.label;
      price.textContent = money(shownPrice);
      submit.hidden = !available;
      submit.disabled = !available;
      if (bis) { bis.hidden = available || isBundle; bis.dataset.variantId = variantInput.value; }
    }
    form.querySelectorAll('[data-purchase-option]').forEach(function (option) { option.addEventListener('change', refreshOffer); });
    if (variantSelect) variantSelect.addEventListener('change', function () {
      var selected = variantSelect.options[variantSelect.selectedIndex];
      variantInput.value = selected.value;
      variantInput.dataset.available = selected.dataset.available;
      submit.dataset.singlePrice = selected.dataset.price;
      var single = form.querySelector('[data-purchase-option][value="single"]');
      if (single) single.dataset.price = selected.dataset.price;
      refreshOffer();
    });
    refreshOffer();
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var option = selectedOption();
      if (!option) return;
      var variantId = option.value === 'bundle' ? submit.dataset.bundleVariant : variantInput.value;
      if (!variantId) { error.textContent = 'This bundle is not available yet.'; error.hidden = false; return; }
      error.hidden = true;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      var originalLabel = label.textContent;
      label.textContent = option.value === 'bundle' ? 'Adding Kitenzo bundle...' : 'Adding to your bag...';
      try {
        var response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) });
        if (!response.ok) throw new Error('We could not add this item. Please try again.');
        window.location.assign(window.Shopify.routes.root + 'cart');
      } catch (reason) {
        error.textContent = reason.message || 'We could not add this item. Please try again.';
        error.hidden = false;
        label.textContent = originalLabel;
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
    });
  });
});

/* Collection filtering and sorting */
(() => {
  const initCollectionFilters = () => {
    document.querySelectorAll('[data-collection-hub]').forEach((hub) => {
      if (hub.dataset.filtersReady) return;
      hub.dataset.filtersReady = 'true';
      const grid = hub.querySelector('[data-product-grid]');
      const items = Array.from(hub.querySelectorAll('[data-product-item]'));
      const category = hub.querySelector('[data-filter-category]');
      const brand = hub.querySelector('[data-filter-brand]');
      const artist = hub.querySelector('[data-filter-artist]');
      const availability = hub.querySelector('[data-filter-availability]');
      const sort = hub.querySelector('[data-filter-sort]');
      const count = hub.querySelector('[data-filter-count]');
      const empty = hub.querySelector('[data-filter-empty]');
      const reset = hub.querySelector('[data-filter-reset]');

      const apply = () => {
        const visible = items.filter((item) => {
          const categoryMatch = category.value === 'all' || item.dataset.category === category.value;
          const brandMatch = brand.value === 'all' || item.dataset.brand === brand.value;
          const artistMatch = artist.value === 'all' || (item.dataset.artists || '').split(' ').includes(artist.value);
          const availabilityMatch = availability.value === 'all' || item.dataset.availability === availability.value;
          item.hidden = !(categoryMatch && brandMatch && artistMatch && availabilityMatch);
          return !item.hidden;
        });

        const sorted = [...items].sort((a, b) => {
          if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
          if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
          if (sort.value === 'newest') return Number(b.dataset.created) - Number(a.dataset.created);
          if (sort.value === 'title') return a.dataset.title.localeCompare(b.dataset.title);
          return Number(a.dataset.featured) - Number(b.dataset.featured);
        });
        sorted.forEach((item) => grid.appendChild(item));
        count.textContent = `${visible.length} ${visible.length === 1 ? 'product' : 'products'}`;
        empty.hidden = visible.length !== 0;
      };

      [category, brand, artist, availability, sort].forEach((control) => control.addEventListener('change', apply));
      reset.addEventListener('click', () => {
        [category, brand, artist, availability].forEach((control) => { control.value = 'all'; });
        sort.value = 'featured';
        apply();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCollectionFilters);
  else initCollectionFilters();
})();


/* Homepage preview links */
(() => {
  const addHomepagePreviewLink = (id, href, label) => {
    const section = document.getElementById(id);
    if (!section || section.querySelector('.ci-home-preview-cta')) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'ci-home-preview-cta';
    const link = document.createElement('a');
    link.href = href;
    link.textContent = label;
    wrapper.appendChild(link);
    section.appendChild(wrapper);
  };
  const initHomepageLinks = () => {
    addHomepagePreviewLink('artists', '/pages/artists', 'Meet all artists');
    addHomepagePreviewLink('community', '/pages/community', 'Explore the community');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHomepageLinks);
  else initHomepageLinks();
})();


/* Release QA: accessible labels remain stable after theme-editor reloads. */
(() => {
  const applyReleaseQaRemediation = () => {
    document.querySelectorAll('.pdp2-thumb').forEach((button, index) => {
      if (button.hasAttribute('aria-label')) return;
      const image = button.querySelector('img');
      const description = button.dataset.galleryAlt || image?.getAttribute('alt') || 'Product image ' + (index + 1);
      button.setAttribute('aria-label', 'View image: ' + description);
    });
    document.querySelectorAll('form[action*="/search"] input[name="q"]').forEach((input) => {
      if (!input.hasAttribute('aria-label') && !input.labels?.length) input.setAttribute('aria-label', 'Search products');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyReleaseQaRemediation, { once: true });
  else applyReleaseQaRemediation();
  document.addEventListener('shopify:section:load', applyReleaseQaRemediation);
})();
(() => {
  const mountShopMegaMenu = () => {
    document.querySelectorAll('.ci-header').forEach((header) => {
      if (header.querySelector('.ci-shop-mega')) return;

      const shopLink = Array.from(header.querySelectorAll('.ci-header__nav > a')).find((link) =>
        link.getAttribute('href')?.includes('/collections/all')
      );
      if (!shopLink) return;

      const mega = document.createElement('div');
      mega.className = 'ci-shop-mega';
      mega.id = 'ci-shop-mega';
      mega.setAttribute('aria-hidden', 'true');
      mega.innerHTML = `
        <nav class="ci-shop-mega__rail" aria-label="Shop categories">
          <div class="ci-shell">
            <a class="is-active" href="/collections/all?sort_by=best-selling">Shop all</a>
            <a href="/collections/coloring-books">Books</a>
            <a href="/collections/gel-pens">Gel pens</a>
            <a href="/collections/pencils">Pencils</a>
            <a href="/collections/watercolor">Watercolor</a>
            <a href="/collections/sketchpads">Sketchpads</a>
            <a href="/collections/journals-cards">Journals &amp; cards</a>
            <a href="/collections/bundles">Bundles</a>
            <a class="ci-shop-mega__deal" href="/collections/monthly-special">Deals</a>
          </div>
        </nav>
        <div class="ci-shop-mega__body ci-shell">
          <div class="ci-shop-mega__lead">
            <a href="/collections/all?sort_by=best-selling">Explore all products <span aria-hidden="true">&rsaquo;</span></a>
            <p>Coloring books, artist tools, and creative supplies for every kind of maker.</p>
          </div>
          <div class="ci-shop-mega__group">
            <h2>Coloring books</h2>
            <a href="/collections/coloring-books">All coloring books</a>
            <a href="/collections/our-best-selling-adult-coloring-books">Best sellers</a>
            <a href="/collections/new-arrivals">New arrivals</a>
            <a href="/collections/digital-downloads">Digital downloads</a>
          </div>
          <div class="ci-shop-mega__group">
            <h2>Coloring tools</h2>
            <a href="/collections/coloring-mediums">All coloring tools</a>
            <a href="/collections/gel-pens">Gel pens</a>
            <a href="/collections/pencils">Colored pencils</a>
            <a href="/collections/watercolor">Watercolor</a>
            <a href="/collections/refills-cases">Refills &amp; cases</a>
          </div>
          <div class="ci-shop-mega__group">
            <h2>Paper &amp; projects</h2>
            <a href="/collections/sketchpads">Sketchpads</a>
            <a href="/collections/journals-cards">Journals &amp; cards</a>
            <a href="/collections/greeting-cards">Greeting cards</a>
            <a href="/collections/cases">Cases</a>
          </div>
          <div class="ci-shop-mega__group">
            <h2>Bundles &amp; offers</h2>
            <a href="/collections/bundles">Bundle and save</a>
            <a href="/collections/monthly-special">Monthly special</a>
            <a href="/collections/new-arrivals">New releases</a>
            <a href="/pages/artists">Shop by artist</a>
          </div>
        </div>`;

      shopLink.classList.add('ci-header__shop-link');
      shopLink.setAttribute('aria-haspopup', 'true');
      shopLink.setAttribute('aria-expanded', 'false');
      shopLink.setAttribute('aria-controls', mega.id);
      header.appendChild(mega);

      const mobileNav = header.querySelector('.ci-header__mobile nav');
      if (mobileNav && !mobileNav.querySelector('.ci-mobile-shop-links')) {
        mobileNav.insertAdjacentHTML('beforeend', `
          <div class="ci-mobile-shop-links">
            <strong>Shop categories</strong>
            <a href="/collections/coloring-books">Coloring books</a>
            <a href="/collections/gel-pens">Gel pens</a>
            <a href="/collections/pencils">Colored pencils</a>
            <a href="/collections/watercolor">Watercolor</a>
            <a href="/collections/sketchpads">Sketchpads</a>
            <a href="/collections/journals-cards">Journals &amp; cards</a>
            <a href="/collections/bundles">Bundles</a>
            <a href="/collections/monthly-special">Deals</a>
          </div>`);
      }

      let closeTimer;
      const open = () => {
        window.clearTimeout(closeTimer);
        header.classList.add('ci-header--shop-open');
        shopLink.setAttribute('aria-expanded', 'true');
        mega.setAttribute('aria-hidden', 'false');
      };
      const close = () => {
        header.classList.remove('ci-header--shop-open');
        shopLink.setAttribute('aria-expanded', 'false');
        mega.setAttribute('aria-hidden', 'true');
      };
      const queueClose = () => {
        closeTimer = window.setTimeout(close, 120);
      };

      shopLink.addEventListener('mouseenter', open);
      shopLink.addEventListener('focus', open);
      mega.addEventListener('mouseenter', open);
      header.addEventListener('mouseleave', queueClose);
      header.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!header.contains(document.activeElement)) close();
        }, 0);
      });
      shopLink.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          open();
          mega.querySelector('a')?.focus();
        }
      });
      mega.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close();
          shopLink.focus();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountShopMegaMenu, { once: true });
  } else {
    mountShopMegaMenu();
  }
})();

;(() => {
  const setupCollectionFilters = () => {
    const panel = document.querySelector('.collection-filters');
    if (!panel || document.querySelector('.collection-filter-toggle')) return;

    if (!panel.id) panel.id = 'CollectionFilters';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'collection-filter-toggle';
    button.setAttribute('aria-controls', panel.id);

    const hasActiveFilter = Array.from(panel.querySelectorAll('select')).some((select) => select.selectedIndex > 0);
    panel.classList.toggle('is-open', hasActiveFilter);
    button.setAttribute('aria-expanded', String(hasActiveFilter));
    button.innerHTML = '<span>Filter & sort</span><span class="collection-filter-toggle__icon" aria-hidden="true">+</span>';

    const syncButton = () => {
      const open = panel.classList.contains('is-open');
      button.setAttribute('aria-expanded', String(open));
      const icon = button.querySelector('.collection-filter-toggle__icon');
      if (icon) icon.textContent = open ? '\u2212' : '+';
    };

    button.addEventListener('click', () => {
      panel.classList.toggle('is-open');
      syncButton();
    });

    panel.before(button);
    syncButton();
  };

  const prioritizePrimaryProductImage = () => {
    const image = document.querySelector('.pdp2-gallery__stage img');
    if (!image) return;
    image.loading = 'eager';
    image.fetchPriority = 'high';
    image.decoding = 'async';
  };

  const initializePublicationFixes = () => {
    setupCollectionFilters();
    prioritizePrimaryProductImage();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePublicationFixes, { once: true });
  } else {
    initializePublicationFixes();
  }

  document.addEventListener('shopify:section:load', initializePublicationFixes);
})();
